module.exports = __webpack_public_path__ + "img/car-2.dc4668ed.jpg";